import { useEffect, useRef, useState } from "react";
import { CardSide } from "@/components/card/CardSide";

export default function PreviewPane({ tpl, data }) {
  const box = useRef(null);
  const [w, setW] = useState(500);
  useEffect(() => {
    const ro = new ResizeObserver(([e]) => setW(e.contentRect.width));
    if (box.current) ro.observe(box.current);
    return () => ro.disconnect();
  }, []);
  const both = tpl.double_sided ?? true;
  const colW = both ? (w - 32) / 2 : w;
  const scale = Math.min(colW / tpl.width, 340 / tpl.height, 7);
  return (
    <div ref={box} className="rounded-xl border border-slate-800 bg-slate-950 studio-grid p-6 min-h-[360px]" data-testid="record-preview">
      <p className="text-[10px] font-mono uppercase tracking-[0.18em] text-slate-500 mb-4">Live preview</p>
      <div className={`flex ${both ? "gap-8" : ""} justify-center items-start flex-wrap`}>
        {["front", ...(both ? ["back"] : [])].map((s) => (
          <div key={s} className="space-y-2">
            <div className="shadow-2xl shadow-black/60"><CardSide tpl={tpl} side={s} data={data} scale={scale} rounded editing testId={`preview-${s}`} /></div>
            <p className="text-[10px] font-mono text-slate-500 text-center uppercase">{s}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
